<div class="container-cart">
  <div></div>
  <!-- MY cart -->
  <div class="column-card">
    <div class="container-info">

      <!-- Header shopping cart -->
      <div class="header-sopping-cart">
        <h2 class="text-header-sopping-cart">Carrito de compras</h2>
        <button type="button" class="close-icon" (click)="onCloseShoppingCart()" aria-label="Cerrar">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Empty shopping cart -->
      <div class="container-img-empty" *ngIf="products.length === 0">
        <div class="empty-cart-info">
          <img class="img-empty" src="./assets/icons/shopping-cart/cesta.png" />
          <div class="text-title-products-empty txt-stl-primary">
            Tu carrito está vacío
          </div>
          <div class="text-products-empty txt-stl-primary txt-stl-second">
            Contamos con una variedad de productos
            para ti para que elijas los que más te gustan.
          </div>
        </div>
        <div class="shopping-cart-empty-btn-container">
          <button class="empty-cart-btn txt txt-stl-primary txt-stl-second" (click)="onCloseShoppingCart()">
            Comenzar a comprar
          </button>
        </div>
      </div>

      <!-- Variable weight -->
      <div class="row info-variable align-items-center" *ngIf="isVariableWeight">
        <div class="col-8 p-2">
          El precio total de este pedido es un aproximado que se confirma luego
          de pesar los productos de tu compra
        </div>
        <div class="col-4 text-end">
          <button type="button" class="link-more" data-toggle="modal" data-target="#info-variable-modal"
            data-dismiss="modal">
            Saber más
          </button>
        </div>
      </div>

      <!-- distribuidor -->
      <div class="row h-100 info-variable" *ngIf="isDistribuidor">
        <div class="col-8 my-auto p-2">
          Este es un pedido de distribuidor
        </div>
      </div>

      <!-- SHOPPING CART with products -->
      <div class="div-all-container scroll-visible" *ngIf="products.length > 0">
        <div id="cart" class="container-all-products">
          <div *ngFor="let product of products; let i = index" class="container-products-cart"
            [class.no-stock]="isNoStock(product)">

            <div class="img-prod">
              <img class="product-image" [src]="product.imagen" alt="product image" />

              <!-- Píldora superior: libras aprox (solo variable) -->
              <div class="pound-tag" *ngIf="product.pesoVariable">
                {{ (product.pesoGramosVariable / 1000) * 2 | number:'1.0-1' }} Lib. aprox.
              </div>

              <!-- Píldora inferior: peso variable -->
              <div class="variable-weight-tag" *ngIf="product.pesoVariable">Peso variable</div>

              <!-- Píldora “Paquete por …gr” cuando NO es variable -->
              <div class="package-pill" *ngIf="!product.pesoVariable">
                Paquete por {{ product.pesoGramos }}gr
              </div>
            </div>

            <div class="info-product">
              <div class="title-product">
                <span class="product-name">{{ product.nombre }}</span>
              </div>

              <!-- Gramaje y $/g -->
              <div class="weight-product" *ngIf="product.pesoVariable">
                {{ product.pesoGramosVariable }}g · $ {{ (product.precio / product.pesoGramos) | number:'1.2-2' }}/g
              </div>
              <div class="weight-product" *ngIf="!product.pesoVariable">
                {{ product.pesoGramos }}g · $ {{ (product.precio / product.pesoGramos) | number:'1.2-2' }}/g
              </div>

              <!-- Precio -->
              <div class="price-line">
                <span class="price-product" *ngIf="product.pesoVariable">
                  {{ pricePerPound(product.precio, product.pesoGramosVariable, product.pesoGramos) | customCurrency }}
                  <span class="unit">Libra</span>
                </span>
                <span class="price-product" *ngIf="!product.pesoVariable">
                  {{ product.precio * product.quantity | customCurrency }}
                </span>
              </div>

              <!-- Controles integrados (+ / - / papelera) -->
              <div class="quantity-product">
                <div class="container-add-remove">
                  <!-- Papelera cuando qty === 1 -->
                  <button type="button" class="icon-circle danger" *ngIf="product.quantity === 1"
                    (click)="deleteProduct(i)" aria-label="Eliminar">
                    <i class="fas fa-trash"></i>
                  </button>

                  <!-- Menos cuando qty > 1 -->
                  <button type="button" class="icon-circle" *ngIf="product.quantity > 1" (click)="onLessProduct(i)"
                    aria-label="Restar">
                    <i class="fas fa-minus"></i>
                  </button>

                  <span class="quantity">{{ product.quantity }}</span>

                  <!-- Más (deshabilitado si no hay stock) -->
                  <button type="button" class="icon-circle"
                    [disabled]="isNoStock(product) || !(product.inventarioBodega[warehouse] > product.quantity)"
                    (click)="onMoreProduct(i)" aria-label="Sumar">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Overlay no bloquea clics -->
            <div class="container-noStock" *ngIf="isNoStock(product)">
              <span class="text-noStock">Sin stock en tienda</span>

              <button type="button" class="remove-all-btn" (click)="deleteProduct(i)"
                aria-label="Eliminar este producto del carrito" title="Eliminar este producto del carrito">
                Eliminar todo
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="resume-total" *ngIf="products.length > 0">
        <div class="title-resume txt-stl-primary">
          Total:
        </div>
        <div class="money-resume txt-stl-primary">
          {{ priceProducts | customCurrency }}
        </div>
      </div>

      <div class="pay" *ngIf="products.length > 0">
        <button type="button" class="pay-btn txt-stl-primary txt-stl-second" [disabled]="isDisabled()"
          [ngStyle]="{'background': (isDisabled())? '#afafaf':'#0e4fa8 0% 0% no-repeat padding-box;'}"
          (click)="navigateCheckout()" *ngIf="coverage === 'SI'">
          Pagar pedido
        </button>
      </div>

      <div class="clean-cart" *ngIf="products.length > 0">
        <button class="clean-cart-btn txt-stl-primary txt-stl-second" (click)="onEmptyShoppingCart()">
          Vaciar carrito
        </button>
      </div>
    </div>


    <div class="container-results">
      <div class="total">
        Total: {{ priceProducts | customCurrency }}
      </div>
      <button class="order-inactive" type="button" *ngIf="coverage === 'NO'" disabled>
        Sin cobertura
      </button>
      <ng-container *ngIf="!validateCheckout">
        <button class="order" type="button" (click)="navigateCheckout()" *ngIf="coverage === 'SI'"
          [disabled]="isDisabled()">
          Continuar pedido
        </button>
      </ng-container>
      <ng-container *ngIf="validateCheckout">
        <button class="order" (click)="onCloseShoppingCart()" *ngIf="coverage === 'SI'" [disabled]="isDisabled()">
          Continuar pedido
        </button>
      </ng-container>
    </div>
  </div>
</div>

<app-modal-info-variable-weight></app-modal-info-variable-weight>
